export function useTableOverflowFade() {
  const tableContainer = ref<HTMLElement>()
  const showFade = ref(false)

  const checkScrollable = () => {
    if (!tableContainer.value) return

    const container = tableContainer.value
    const hasOverflow = container.scrollWidth > container.clientWidth
    const isScrolledToEnd = container.scrollLeft >= container.scrollWidth - container.clientWidth - 1

    showFade.value = hasOverflow && !isScrolledToEnd
  }

  onMounted(() => {
    if (tableContainer.value) {
      checkScrollable()
      tableContainer.value.addEventListener('scroll', checkScrollable)
      window.addEventListener('resize', checkScrollable)
    }
  })

  onUnmounted(() => {
    if (tableContainer.value) {
      tableContainer.value.removeEventListener('scroll', checkScrollable)
      window.removeEventListener('resize', checkScrollable)
    }
  })

  return {
    tableContainer,
    showFade,
    checkScrollable,
  }
}
